var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScoreCardEmptyStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.34041 0.0140244C8.0919 -0.128893 8.2071 0.856082 8.46492 1.35115C8.85982 2.11667 9.29313 2.97917 9.84163 3.65288C11.0374 5.12777 12.9627 5.88308 14.7618 6.55172C15.5516 7.49582 14.1804 7.63367 13.5057 7.92965C12.3593 8.42978 11.0703 9.04225 10.2147 9.92519C9.16694 11.0071 8.54717 12.482 7.94928 13.8141C7.71343 14.0846 7.20332 14.0489 7.00034 13.7783C6.7535 13.4466 6.45183 12.4667 6.21598 12.0176C5.03118 9.76698 3.87934 8.97079 1.48778 7.92965C1.16968 7.79188 0.182333 7.52648 0.0726657 7.30188C-0.0589689 7.04164 -0.0151184 6.73544 0.231718 6.55172C0.527937 6.3322 1.61396 6.026 2.04727 5.827C4.60333 4.6583 5.35482 3.63244 6.5506 1.29498C6.73707 0.927541 6.89612 0.0956239 7.35139 0.00887483L7.34041 0.0140244ZM12.8036 6.93445C10.2531 6.07702 8.51422 4.32144 7.48856 2.02478C6.589 3.92335 5.50289 5.26562 3.56669 6.32206C3.17178 6.53635 2.64516 6.69456 2.27767 6.91401C2.19542 6.96511 2.1296 6.90387 2.168 7.08759C4.70755 7.8837 6.4738 9.7261 7.48303 11.9972C8.17968 10.5529 9.04629 9.23104 10.4285 8.27157C11.18 7.751 12.0522 7.41422 12.7981 6.93445H12.8036Z",
    fill: "#F5F5F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreCardEmptyStar);
export default __webpack_public_path__ + "static/media/score-card-empty-star.5eade7d819f39d50a73052b856ee30c6.svg";
export { ForwardRef as ReactComponent };